import styled from 'styled-components';

export default styled.h3`
  font-size: 1.25rem;
  font-weight: 500;
  text-align: center;
  margin-bottom: 2rem;
`;
